export const fieldGroupStyles = "flex flex-wrap mb-4 w-full cursor-pointer";
export const labelStyles = "block tracking-wider font-bold text-base mb-2";
